import React, {useEffect, useCallback} from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid';

import recurrenceUpdateStyles from '../styles/components/recurrenceUpdateModal.module.scss';
import { X } from 'react-feather';
import Button from './Button';

const RecurrenceUpdateModal = ({ actionType, onThisOnly, onAll, onThisAndFuture, showThisAndFuture, showThisOnly, showAll, onClose, eventType }) => {
    const escFunction = useCallback((event) => {
        if(event.keyCode === 27) {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
          document.removeEventListener("keydown", escFunction, false);
        };
      }, [escFunction]);
    return (
        <section className={[recurrenceUpdateStyles.alertPrompt__background, recurrenceUpdateStyles.__active].join(' ')}>
            <section className={recurrenceUpdateStyles.alertPrompt__card}>
                <header className={recurrenceUpdateStyles.alertPrompt__header}>
                    <Row start="xs" between="xs" middle="xs">
                        <Col xs={11}>
                            <h4>
                                {`This is a repeating ${eventType}`}
                            </h4>
                        </Col>
                        <Col xs={1}>
                            <span className={recurrenceUpdateStyles.alertPrompt__close} onClick={onClose}>
                                <X size={24} color="#C61C33"/>
                            </span>
                        </Col>
                    </Row>
                </header>
                <section className={recurrenceUpdateStyles.alertPrompt__form}>
                    <Row center="xs">
                        <Col xs={12} className={recurrenceUpdateStyles.alertPrompt__content}>
                            {`What do you want to do?`}
                        </Col>
                        { showThisOnly &&
                            <Col xs={12}>
                                <Row center="xs">
                                    <Col xs={12}>
                                        <Button
                                            label={`${actionType} this ${eventType} only`}
                                            login
                                            click={onThisOnly}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        }
                        { showThisAndFuture &&
                            <Col xs={12}>
                                <Row center="xs">
                                    <Col xs={12}>
                                        <Button
                                            label={`${actionType} this and future ${eventType}s`}
                                            login
                                            click={onThisAndFuture}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        }
                        { showAll &&
                            <Col xs={12}>
                                <Row center="xs">
                                    <Col xs={12}>
                                        <Button
                                            label={`${actionType} all ${eventType}s`}
                                            login
                                            click={onAll}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        }
                        <Col xs={12}>
                            <Row center="xs">
                                <Col xs={12}>
                                    <Button
                                        label="Cancel"
                                        cancel={true}
                                        click={onClose}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>
            </section>
        </section>
    )
}

RecurrenceUpdateModal.propTypes = {
    onThisOnly: PropTypes.func.isRequired,
    onAll: PropTypes.func.isRequired,
    onThisAndFuture: PropTypes.func.isRequired,
    showThisAndFuture: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    eventType: PropTypes.string.isRequired,
}

export default RecurrenceUpdateModal
